// extracted by mini-css-extract-plugin
module.exports = {"group":"login_form_group-module__group--2u9SN"};